import React, { useEffect, Suspense, lazy } from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { BlinkTestSection } from './components/BlinkTestSection';
import { IntroSection } from './components/IntroSection';
import { OilProblemSection } from './components/OilProblemSection';
import { EyeDropsSection } from './components/EyeDropsSection';
import { HiddenSignsSection } from './components/HiddenSignsSection';
import { TestimonialSection } from './components/TestimonialSection';
import { DailyRitualSection } from './components/DailyRitualSection';
import { ComparisonSection } from './components/ComparisonSection';
import { DangersSection } from './components/DangersSection';
import { TwoChoicesSection } from './components/TwoChoicesSection';
import { CallToAction } from './components/CallToAction';
import { FAQSection } from './components/FAQSection';
import { ReviewsSection } from './components/ReviewsSection';
import { useRevealAnimation } from './utils/IntersectionObserverUtil';
export function App() {
  // Use centralized reveal animation
  useRevealAnimation();
  return <div className="flex flex-col w-full min-h-full bg-white" data-id="element-0">
      <Header data-id="element-1" />
      <Hero data-id="element-2" />
      <main className="flex flex-col w-full max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-3">
        <BlinkTestSection data-id="element-4" />
        <IntroSection data-id="element-5" />
        <OilProblemSection data-id="element-6" />
        <DailyRitualSection data-id="element-7" />
        <ComparisonSection data-id="element-8" />
        <CallToAction data-id="element-9" />
        <DangersSection data-id="element-10" />
        <EyeDropsSection data-id="element-11" />
        <TwoChoicesSection data-id="element-12" />
        <CallToAction data-id="element-13" />
        <FAQSection data-id="element-14" />
        <ReviewsSection data-id="element-15" />
      </main>
      <footer className="w-full py-6 bg-gray-50 mt-16" data-id="element-16">
        <div className="max-w-4xl mx-auto px-4 text-center text-gray-500 text-sm" data-id="element-17">
          <p data-id="element-18">© 2024 iReliefTech Innovations. All rights reserved.</p>
          <p className="mt-2" data-id="element-19">
            These statements reflect user experiences. Individual results may
            vary. This product is designed to support eye comfort and is not
            intended to diagnose, treat, cure, or prevent any medical condition.
            Consult your eye care professional if you have concerns about your
            eye health..
          </p>
          <p className="mt-2" data-id="element-20">
            *These statements have not been evaluated by the FDA. This device is
            not intended to diagnose, treat, cure, or prevent any disease.
            Individual results may vary. Offer valid while supplies last.
            Protected by our 90-Day Money Back Guarantee — try it risk-free.
          </p>
          <p className="mt-2" data-id="element-21">
            This article contains affiliate links. We only recommend products
            that have helped thousands recover from various symptoms. Results
            vary by individual.
          </p>
        </div>
      </footer>
    </div>;
}